import PropTypes from "prop-types";
import { formFieldCommonType } from "../common-type";

export const CheckBoxProps = {
  ...formFieldCommonType,
  size: PropTypes.oneOf(["small", "medium"]),
  icon: PropTypes.element,
  labelPlacement: PropTypes.oneOf(["start", "end"]),
  labelWidth: PropTypes.string,
  sx: PropTypes.object,
};
